import { atom } from "jotai";

import {
  DiningBookingWizardCurrentStepAtom,
  DiningBookingWizardListOfStepsAtom,
} from "../../stores";

export const isFinalDiningStepAtom = atom((get) => {
  const steps = get(DiningBookingWizardListOfStepsAtom);
  const currentStep = get(DiningBookingWizardCurrentStepAtom);

  if (!currentStep || steps.length === 0) {
    return false;
  }

  const currentIndex = steps.indexOf(currentStep);
  return currentIndex !== -1 && currentIndex === steps.length - 1;
});
